const OrderType = {
  Ascending: 'Ascending',
  Descending: 'Descending',
};

export default OrderType;
